import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FooterService {
  private footerVisibility = new BehaviorSubject<boolean>(true);
  public isFooterVisible$ = this.footerVisibility.asObservable();

  showFooter() {
      this.footerVisibility.next(true);
  }

  hideFooter() {
      this.footerVisibility.next(true);
  }
}
